// extracted by mini-css-extract-plugin
module.exports = {"m-container":"internal-motive_component_m-container__Q1Zvh","gcontainer":"internal-motive_component_gcontainer__PZ10S"};